import { ButtonType, Form, CustomButton, Modal, ModalBody, ModalFooter, ModalSize } from "soprasteria-ui-library";
import * as React from "react";

interface INoAccessModal {
    noAccessText: string;
    id: string;
}

export const NoAccessModal: React.FunctionComponent<INoAccessModal> = ({ noAccessText, id }) => {
    return (
        <Modal header="Rättigheter saknas" id={id} preventCloseOnOutsideClick={false} modalSize={ModalSize.normal}>
            <Form>
                <ModalBody>
                    <p>{noAccessText}</p>
                </ModalBody>
                <ModalFooter>
                    <div className="text-right btn-group" role="group">
                        <CustomButton buttonType={ButtonType.general} data-dismiss="modal" buttonText="Stäng" />
                    </div>
                    <input type="hidden" data-toggle="modal" id={`open-${id}`} data-target={`#${id}`} />
                </ModalFooter>
            </Form>
        </Modal>
    )
}